/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import {
  setAuthCookies,
  getAuthCookies,
  removeAuthCookies,
} from 'lorautils/cookies/auth';
import { APIStatus } from '../actions/api';
import { types } from '../actions/auth';


export default (state, action) => {
  const { type } = action;
  if (type === types.token) {
    /* Log in */
    const { meta: { api } } = action;
    switch (api.status) {
      case APIStatus.API_PENDING:
        return {
          authed: false,
          status: 'pending',
        };
      case APIStatus.API_SUCCESS:
        setAuthCookies(api.response);
        return {
          authed: true,
          ...api.response,
        };
      case APIStatus.API_FAILURE:
        return {
          authed: false,
          error: api.error,
        };
      default:
        return { authed: false };
    }
  } else if (type === types.revoke) {
    /* Log out */
    const { meta: { api } } = action;
    if (APIStatus.complete(api.status)) {
      removeAuthCookies();
      return { authed: false };
    }
    return { authed: false };
  } else {
    /* If any api invoke return BADTOKEN */
    const {
      meta: {
        api: {
          error: { code = '' } = {},
        } = {},
      } = {},
    } = action;
    if (code === 'BADTOKEN') {
      return { authed: false };
    }
    /* Check auth token */
    const auth = getAuthCookies();
    if (auth) {
      return { authed: true, ...auth, status: 'cookies' };
    }
    return { authed: false, status: 'idle' };
  }
};




// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js